export default function getCurrencySymbol(currency) {
  const currencyToLocaleMapper = {
    INR: 'en-IN',
    SAR: 'en-SA',
    EUR: 'de-DE',
    USD: 'en-US',
  };

  const locale = currencyToLocaleMapper[currency] || 'en-US';

  // Format a dummy number using currency style
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(0);
  // Extract symbol (remove digits and punctuation)
  const symbol = formatted.replace(/\d|[.,\s]/g, '').trim();

  return symbol;
}
